export const DOCUMENT_TEMPLATE_GET_CHECKSUM = `
  query($document_template_id: Long!) {
    document_template_checksum(document_template_id: $document_template_id) {
      id
      checksum
    }
  }
`;